import { TrackItem, TrackSegment } from '../types'
import {
  getSegmentPosition,
  getTrackPosition,
  SegmentPositionOptions,
  TrackPositionOptions,
} from './track-coord'
import { frame2px } from './frame'
import { Rect } from '@com/type'

export function getTrackRect(
  track: TrackItem,
  options: Pick<TrackPositionOptions, 'gap' | 'tracks'>,
): Rect {
  return {
    x: 0,
    y: getTrackPosition({
      id: track.id,
      ...options,
    }).top,
    width: Infinity,
    height: track.height,
  }
}

export function getSegmentRect(
  segment: TrackSegment,
  options: SegmentPositionOptions,
): Rect {
  const { frameWidth, tracks } = options
  const segmentPosition = getSegmentPosition(segment, options)
  const t = tracks.find((t) => t.id === segment.trackId)

  return {
    x: segmentPosition.x,
    y: segmentPosition.y,
    width: frame2px(segment.frames, frameWidth),
    height: t?.height ?? 0,
  }
}

export function isRectangleOverlap(
  rect1: Rect,
  rect2: Rect,
  thresholdX = 0,
  thresholdY = 0,
): boolean {
  // x轴的交集
  const maxX = Math.max(rect1.x, rect2.x)
  const minX = Math.min(rect1.x + rect1.width, rect2.x + rect2.width)
  const overlapX = maxX < minX && minX - maxX >= thresholdX

  // y轴的交集
  const maxY = Math.min(rect1.y + rect1.height, rect2.y + rect2.height)
  const minY = Math.max(rect1.y, rect2.y)
  const overlapY = maxY > minY && maxY - minY >= thresholdY
  return overlapY && overlapX
}
